export function makeIban(string) {

	if (!string) return '-'

	let arr = string.split('');

	let iban = [];

	arr.forEach((item, index) => {
		iban.push(item);
		if ((index + 1) % 4 == 0) iban.push(' ');
	});

	return iban.join('')
}